// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import polpartyEntity from './entities/polparty.json';
import polpartyMenu from '../pages/polparty/menu.json';
import polpartyFullForm from '../pages/polparty/forms/full.json';
import polpartyContextForm from '../pages/polparty/forms/context.json';
import polpartyMiniForm from '../pages/polparty/forms/mini.json';
import polpartyLookupForm from '../pages/polparty/forms/lookup.json';
import polpartyTableView from '../pages/polparty/views/table.json';
import polpartyStagesView from '../pages/polparty/views/stages.json';
import polpartyCardsView from '../pages/polparty/views/cards.json';
import polpartyInlineView from '../pages/polparty/views/inline.json';
import polpartyBacklogView from '../pages/polparty/views/backlog.json';
import polpartySplitView from '../pages/polparty/views/split.json';
import polpartyCalendarView from '../pages/polparty/views/calendar.json';
import polpartyDashboardView from '../pages/polparty/views/dashboard.json';

/** Тип запису «Політична партія» зі сторінками пакета: меню, форми та подання з pages/polparty/. */
export const polpartyDefinition: IRecordTypeDefinition = {
  ...polpartyEntity,
  views: assembleViewSet({
      table: polpartyTableView,
      stages: polpartyStagesView,
      cards: polpartyCardsView,
      inline: polpartyInlineView,
      backlog: polpartyBacklogView,
      split: polpartySplitView,
      calendar: polpartyCalendarView,
      dashboard: polpartyDashboardView,
  }),
  form: polpartyFullForm,
  forms: { full: polpartyFullForm, context: polpartyContextForm, mini: polpartyMiniForm, lookup: polpartyLookupForm },
  menu: polpartyMenu,
} as IRecordTypeDefinition;
